import Icon from '../components/Icon.vue'

Icon.register({"redo":{"width":512,"height":512,"paths":[{"d":"M500.3 0H452.9C446.1 0 440.6 5.7 440.9 12.6L444.9 95.3C399.4 41.9 331.7 8 256 8 119.3 8 7.9 119.5 8 256.2 8.1 393.1 119.1 504 256 504 319.9 504 378.2 479.8 422.2 440.1 427.3 435.5 427.5 427.5 422.7 422.7L388.7 388.7C384.2 384.2 377 384 372.3 388.1 341.3 415.4 300.6 432 256 432 158.7 432 80 353.3 80 256 80 158.7 158.7 80 256 80 316.9 80 370.5 110.9 402.1 157.8L300.6 152.9C293.7 152.6 288 158.1 288 164.9V212.3C288 219 293.4 224.3 300 224.3H500.3C507 224.3 512.3 219 512.3 212.3V12C512.3 5.4 507 0 500.3 0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/redo.js
// module id = GFIs
// module chunks = 0